module.exports = __webpack_public_path__ + "img/qrcode_jia.8c87dde6.png";